<template>
  <div class="zxs-banner" :class="{ 'preview-mode': pageType === 1 }">
    <div
      class="swiper-con"
      ref="swipecon"
      id="swiper-con"
      v-if="swipeShow"
      @click="onlyOneData(resource)"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide items"
          v-for="(resource, index) in resource"
          :key="index"
          :style="{ backgroundImage: 'url(' + resource.content + ')' }"
        >
          <div v-if="aosTag[index] === 301" class="ad-text">广告</div>
        </div>
        <!-- <div class="swiper-slide items"></div>
          <div class="swiper-slide items"></div>
        <div class="swiper-slide items"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
/** *
 * 项目如果没有swiper4需要引入，注意路径
 */
import {
  loader, log, native, webviewInfo, util
} from '@ali/amap-lib';
import Swiper from '../../../../common/js/modules/swiper4';

export default {
  name: 'banner',
  props: ['pageType'],
  data() {
    return {
      amsfrom: '',
      swipeShow: false,
      banner: [],
      ch: 667, // 屏幕的高度
      x: 0, // 经度
      y: 0, // 维度
      resource: [],
      action: [],
      during: 3, // 切换时间
      adId: [], // 广告id
      aosTag: [], //
      msgId: [], // 广告banner标识，普通banner为空
      externalInfo: [], // 服务下发标识，用于透传给埋点参数
      tag: 10, // 标签
      source_from: 1, // 0push,1消息盒子
      isShow: [],
      bannerH: 0,
      canSee: null, // 元素在屏幕中
      Swiper: null,
      bannerList: '',
      test: 'https://oss.testing.amap.com/ws/banner/lists',
      public: 'https://oss.amap.com/ws/banner/lists'
    };
  },
  created() {
    // log.initLog('');
    this.ch = document.documentElement.clientHeight || window.innerHeight;
    this.amsfrom = util.getUrlParam('amsfrom') === 'push' ? '0' : '1';
  },
  mounted() {
    native.getMapLocation((res) => {
      console.log(res);
      this.x = res.lon;
      this.y = res.lat;
      this.getBannerAos();
    });
  },
  methods: {
    getBannerAos() {
      const from = util.getUrlParam('amsfrom') === 'push' ? 0 : 1;
      const event = util.getUrlParam('via').split('-')[1] || 'COMMON_TRAFFIC';
      const cid = util.getUrlParam('cid') || '1';
      const params = [
        { x: this.x, sign: 1 },
        { y: this.y, sign: 1 },
        { page_id: '48' },
        { push_event: event },
        { msg_cid: cid },
        { sourceFrom: from }
      ];
      this.bannerlist = webviewInfo.isPublic() ? this.public : this.test;
      loader.load(
        this.bannerlist,
        params,
        (res) => {
          if (parseInt(res.code, 10) === 1) {
            this.banner = res.data;
            if (!(this.banner instanceof Array)) {
              return;
            }
            this.during = (this.banner[0] && this.banner[0].slide_time) || 3;
            this.banner.forEach((items) => {
              this.adId.push(items.id);
              this.msgId.push(items.msg_id);
              this.externalInfo.push(items.lba_extra.external_info);
              if (items.resource[0] && items.resource[0].content) {
                this.resource.push(items.resource[0]);
              }
              this.action.push(items.action);
              this.aosTag.push(parseInt(items.tag, 10));
            });
            if (this.resource.length) {
              this.swipeShow = true;
            } else {
              this.$emit('bannerHide');
            }
            this.initMove();
          }
        },
        '',
        false,
        'get'
      );
    },
    initMove() {
      const self = this;
      this.$nextTick(() => {
        this.bannerH = this.$refs.swipecon && this.$refs.swipecon.offsetHeight;
        if (this.resource.length > 1 && this.$refs.swipecon) {
          this.Swiper = new Swiper(this.$refs.swipecon, {
            loop: true,
            autoplay: {
              delay: self.during * 1000,
              disableOnInteraction: false
            },
            on: {
              slideChangeTransitionEnd() {
                if (this.realIndex) {
                  if (!self.isShow[this.realIndex]) {
                    self.isShow[this.realIndex] = true;
                    log.nativeOnlineLog('', {
                      operateType: 1,
                      tag: self.tag,
                      gaode_lba_id: 'ad_display',
                      msg_id: self.msgId[this.realIndex],
                      source_from: this.amsfrom,
                      external_info: JSON.stringify(self.externalInfo[this.realIndex])
                    });
                  }
                }
              },
              tap() {
                console.log(this.realIndex, self.action);
                const urlorschema = self.action[this.realIndex].url;
                const type = parseInt(self.action[this.realIndex].type, 10);
                if (!urlorschema) {
                  return;
                }
                log.nativeOnlineLog('', {
                  operateType: 2,
                  tag: self.tag,
                  gaode_lba_id: 'ad_display',
                  msg_id: self.msgId[this.realIndex],
                  source_from: this.amsfrom,
                  external_info: JSON.stringify(self.externalInfo[this.realIndex])
                });
                if (type === 4) {
                  native.loadSchema(urlorschema);
                }
                if (type === 1 || type === 2) {
                  native.loadSchema(urlorschema);
                }
              }
            }
          });
          if (this.Swiper) {
            this.Swiper.autoplay.stop();
          }
        }
        this.logStatic();
        this.addEvent();
      });
    },
    onlyOneData(data) {
      if (data.length !== 1) {
        return;
      }
      if (data.length === 1) {
        const urlorschema = this.action[0].url;
        const type = parseInt(this.action[0].type, 10);
        if (!urlorschema) {
          return;
        }
        log.nativeOnlineLog('', {
          operateType: 2,
          tag: this.tag,
          gaode_lba_id: 'ad_display',
          msg_id: this.msgId[0],
          source_from: this.amsfrom,
          external_info: JSON.stringify(this.externalInfo[0])
        });
        if (type === 4) {
          native.loadSchema(urlorschema);
        }
        if (type === 1 || type === 2) {
          native.loadSchema(urlorschema);
        }
      }
    },
    logStatic() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.swipecon) {
            this.canSee = (this.$refs.swipecon.getBoundingClientRect().top > 0
                && this.$refs.swipecon.getBoundingClientRect().top
                  < this.ch - this.bannerH / 2)
              || (this.$refs.swipecon.getBoundingClientRect().top < 0
                && this.$refs.swipecon.getBoundingClientRect().top
                  > -this.bannerH);
          }
          if (this.canSee) {
            if (this.Swiper) {
              this.Swiper.autoplay.start();
            }
            if (!this.isShow[0]) {
              this.isShow.push(true);
              log.nativeOnlineLog('', {
                operateType: 1,
                tag: this.tag,
                gaode_lba_id: 'ad_display',
                msg_id: this.msgId[0],
                source_from: this.amsfrom,
                external_info: JSON.stringify(this.externalInfo[0])
              });
            }
          }
        }, 300);
      });
    },
    addEvent() {
      window.addEventListener(
        'scroll',
        () => {
          if (this.$refs.swipecon) {
            this.canSee = (this.$refs.swipecon.getBoundingClientRect().top > 0
                && this.$refs.swipecon.getBoundingClientRect().top
                  < this.ch - this.bannerH / 2)
              || (this.$refs.swipecon.getBoundingClientRect().top < 0
                && this.$refs.swipecon.getBoundingClientRect().top
                  > -this.bannerH);
          }

          if (this.canSee) {
            if (!this.isShow[0]) {
              log.nativeOnlineLog('', {
                operateType: 1,
                tag: this.tag,
                gaode_lba_id: 'ad_display',
                msg_id: this.msgId[0],
                source_from: this.amsfrom,
                external_info: JSON.stringify(this.externalInfo[0])
              });
              this.isShow.push(true);
            }
            if (!this.Swiper) {
              return;
            }
            if (this.Swiper.autoplay.running) {
              return;
            }
            this.Swiper.autoplay.start();
          } else if (this.Swiper) {
            this.Swiper.autoplay.stop();
          }
        },
        false
      );
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../css/index";
@import "../../../../common/css/common-mixin";
@import "../../css/swiper.css";
.zxs-banner {
  width: 100%;
  // margin: rpx(60) auto;
  margin-bottom: rpx(40);
  border-radius: rpx(12) !important;
  overflow: hidden !important;
  .swiper-con {
    width: rpx(670);
    height: rpx(162);
    margin: rpx(40) auto;
    background-color: #f0f0f0;
    box-shadow: 0 1px 1px 0 rgba(213, 213, 213, 0.2),
      2px 2px 2px 0 rgba(5, 5, 5, 0.08);
    border-radius: rpx(12);
    overflow: hidden;
    .items {
      background-color: #f0f0f0;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      position: relative;
      border-radius: rpx(12);
      overflow: hidden;
      .ad-text {
        position: absolute;
        left: 0;
        bottom: 0;
        width: rpx(64);
        height: rpx(40);
        background-color: rgba(0, 0, 0, 0.7);
        font-size: rpx(24);
        line-height: rpx(40);
        text-align: center;
        color: #ffffff;
        border-bottom-left-radius: rpx(12);
      }
    }
  }
}
.preview-mode {
  margin: 0;
  padding: 0;
}
</style>
